import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { APP_ROUTES } from '../constants/app-route.constants';

@Injectable({ providedIn: 'root' })
export class TempAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem('temp_token');
    if (!token) {
      this.router.navigateByUrl(APP_ROUTES.AUTH.LOGIN);
      return false;
    }
    return true;
  }
}
